import {DataManager} from '@ornery/web-components';
const dataManagerInstance = new DataManager();
export default dataManagerInstance;
